import React from 'react'
import Container from '../../ui/container/Container'
import { useSelector } from 'react-redux';
import { getFileUrl } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { FORM_ROUTE, SHOW_FORM_ROUTE } from '../../../routes/web/rootRoutes';

function DownloadApply() {
  const navigate = useNavigate();
  const forms = useSelector((state) => state.globalState?.siteSetting?.formData);

  const handleApply = (formType) => {
    if(localStorage.getItem('useAccessToken') !== null) return navigate(FORM_ROUTE(formType));
    navigate('/auth/login')
  };

  const stripHtml = (html) => {
    if (typeof window === 'undefined') return html || "";
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const getFormColor = (type) => {
    const colorMap = {
      'Membership': 'bg-amber-100 text-amber-800 border-amber-200',
    };

    for (const [key, value] of Object.entries(colorMap)) {
      if (type.includes(key)) return value;
    }

    return 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const getFormIcon = (type) => {
    const iconMap = {
      'MEDICAL': '🏥',
      'REGISTRATION': '📝',
      'Membership': '👥',
      'UPGRADATION': '📈',
      'COMPLAINT': '📢'
    };

    for (const [key, value] of Object.entries(iconMap)) {
      if (type.includes(key)) return value;
    }

    return '📄';
  };

  return (
    <div className='bg-gradient-to-br from-blue-50 to-indigo-50'>
      <Container>
        <div className="min-h-screen ">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 mb-4">Available Forms</h1>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Browse through our collection of forms for various services. Apply online or download the forms for offline use.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {forms?.map((form) => {
                const formColor = getFormColor(form.type);
                const formIcon = getFormIcon(form.type);

                return (
                  <div
                    key={form.id}
                    className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col"
                  >
                    <div className={`p-5 border-b ${formColor} flex items-center justify-between`}>
                      <div className="flex items-center">
                        <span className="text-2xl mr-3">{formIcon}</span>
                        <span className="text-sm font-semibold">{form.type.split(' ')[0]}</span>
                      </div>
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white bg-opacity-80">
                        {form.status}
                      </span>
                    </div>

                    <div className="p-6 flex-grow">
                      <div className="flex justify-between items-start mb-4">
                        <h2 className="text-lg font-bold text-gray-900 leading-tight">{form.title}</h2>
                        <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                          {new Date(form.created_at).toLocaleDateString()}
                        </span>
                      </div>

                      {form.sub_heading && form.sub_heading !== form.title && (
                        <p className="text-sm text-gray-600 mb-4">{form.sub_heading}</p>
                      )}

                      <div className="text-sm text-gray-700 mb-6 bg-gray-50 p-4 rounded-lg">
                        {stripHtml(form.description).length > 120
                          ? `${stripHtml(form.description).substring(0, 120)}...`
                          : stripHtml(form.description)
                        }
                      </div>
                    </div>

                    <div className="p-5 bg-gray-50 border-t border-gray-100">
                      <div className="flex flex-col sm:flex-row gap-3">
                        <button
                          onClick={() => handleApply(form.type)}
                          className="flex-1 flex items-center justify-center cursor-pointer bg-violet-600 font-semibold hover:bg-violet-800 text-white text-sm  py-3 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
                        >
                          <span className="mr-2">📋</span>
                          Apply Now
                        </button>
                        <a
                          href={getFileUrl(form?.form, 'form')}
                          target='_blank'
                          className="flex-1 flex items-center justify-center cursor-pointer border border-gray-300 hover:bg-zinc-400 hover:text-white text-gray-700 text-sm font-medium py-3 px-4 rounded-lg transition-all duration-300"
                        >
                          <span className="mr-2">⬇️</span>
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </Container>
    </div>

  );
};

export default DownloadApply
